export const NAV_ITEMS = [
  { label: '首页', path: '/' },
  { label: '找商标', path: '/search' },
  { label: '商标注册', path: '/register' },
  { label: '商标转让流程', path: '/transfer' },
  { label: '商标异议', path: '/objection' },
  { label: '商标资讯', path: '/news' }
]

export const WHY_CHOOSE_ITEMS = [
  { no: '01', title: '节省时间', desc: '购买现成商标，即买即用' },
  { no: '02', title: '提高成功率', desc: '成熟商标转让成功率高' },
  { no: '03', title: '规避风险', desc: '规避注册被驳回的风险' },
  { no: '04', title: '直接获得商标', desc: '权利清晰，无需等待注册周期' }
]

export const PROCESS_STEPS = [
  { no: '01', title: '选商标', subtitle: 'CHOOSE LOGO' },
  { no: '02', title: '签订合同', subtitle: 'SIGN CONTRACT' },
  { no: '03', title: '办理公证', subtitle: 'NOTARIZE' },
  { no: '04', title: '确认付款', subtitle: 'PAYMENT' },
  { no: '05', title: '上报商标局', subtitle: 'SUBMIT' }
]

export const PLATFORM_STATS = [
  { value: '300+', label: '专业顾问团队' },
  { value: '500000+', label: '商标资源' },
  { value: '98.8%', label: '客户满意度' },
  { value: '7×24h', label: '在线客服' }
]

export const FOOTER_INFO = {
  hotline: '18824297631',
  address: '公司地址：广东省深圳市宝安区荣超滨海大厦A座1003',
  icp: '粤ICP备53929104064-1号',
  icpUrl: 'https://beian.miit.gov.cn/',
  disclaimer:
    '免责声明：本网站部分内容由用户自行上传，如权利人发现存在错误传其作品情况，请及时与本站联系删除：info@dongbiaodi.top'
}

export const FOOTER_NAV_LINKS = [
  { label: '关于我们', path: '/about' },
  { label: '联系我们', path: '/contact' },
  { label: '帮助中心', path: '/help' },
  { label: '公司资质', path: '/qualification' },
  { label: '隐私政策', path: '/privacy' }
]

const footerAsset = name =>
  require(`../../homepage/底部图标及效果图(1)/bottom/${name}`)

export const SERVICE_GUARANTEE_ITEMS = [
  { icon: footerAsset('icon1.jpg'), alt: '标准价格' },
  { icon: footerAsset('icon2.jpg'), alt: '标准资源' },
  { icon: footerAsset('icon3.jpg'), alt: '标准交付' },
  { icon: footerAsset('icon4.jpg'), alt: '资金安全' },
  { icon: footerAsset('icon5.jpg'), alt: '爽约必赔' }
]

export const FOOTER_QRCODES = [
  { image: footerAsset('ewm.jpg'), label: '懂标帝知产公众号' },
  { image: footerAsset('ewm.jpg'), label: '扫码添加客服' }
]
